import React, { useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  CoffeeOutlined,
  TeamOutlined,
  BarChartOutlined,
  SettingOutlined,
  LogoutOutlined,
  BulbOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Layout, Menu, message } from "antd";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";

import { HomePage } from "../../components/homepage";
import { UsersMaster } from "./components/users";
import { SysData } from "./components/sysdata";
import { StudentsMaster } from "./components/students";
import { Indictors } from "./components/indictors";
import { EvaluateRecords } from "./components/evaluateResult";

const { Header, Sider, Content } = Layout;

export const MasterHome = (params) => {
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (!userInfo) {
    message.error("请登录！！！");
    history.push("/");
  }

  const getItem = (label, key, icon, children) => {
    return {
      key,
      icon,
      children,
      label,
      onClick: () => handleMenuClick(key),
    };
  };

  // 菜单点击处理函数
  const handleMenuClick = (key) => {
    switch (key) {
      case "1":
        history.push("/masterhome/home");
        break;
      case "2":
        history.push("/masterhome/users");
        break;
      case "3":
        history.push("/masterhome/students");
        break;
      case "4":
        history.push("/masterhome/indictors");
        break;
      case "5":
        history.push("/masterhome/evaluateResult");
        break;
      case "6":
        history.push("/masterhome/sysdata");
        break;
      default:
        break;
    }
  };

  const items = [
    getItem("首页", "1", <CoffeeOutlined />),
    getItem("系统用户管理", "2", <TeamOutlined />),
    getItem("学生信息管理", "3", <UserOutlined />),
    getItem("评价指标管理", "4", <BarChartOutlined />),
    getItem("评价记录管理", "5", <BulbOutlined />),
    getItem("系统数据备份", "6", <SettingOutlined />),
  ];

  return (
    <div className="Homediv">
      <Layout id="components-layout-demo-custom-trigger">
        <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo" style={{overflow:"hidden",borderRadius:"6px"}} >欢迎您{userInfo.role}:{userInfo.full_name}</div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
            items={items}
          />
        </Sider>
        <Layout className="site-layout">
          <Header
            className="site-layout-background"
            style={{
              padding: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: "trigger",
                onClick: () => setCollapsed(!collapsed),
              }
            )}
            <div
              className="logout"
              onClick={() => {
                history.push("/");
                localStorage.removeItem("userInfo");
              }}
            >
              <LogoutOutlined />
            </div>
          </Header>
          <Content
            className="site-layout-background"
            style={{
              margin: "24px 16px",
              padding: 24,
              minHeight: 280,
            }}
          >
            <Switch>
              <Route path="/masterhome/home" component={HomePage} />
              <Route path="/masterhome/users" component={UsersMaster} />
              <Route path="/masterhome/students" component={StudentsMaster} />
              <Route path="/masterhome/indictors"  component={Indictors} />
              <Route
                path="/masterhome/evaluateResult"
                render={() => <EvaluateRecords userInfo={userInfo} />}
              />
              <Route path="/masterhome/sysdata" component={SysData} />
              <Redirect from="/masterhome" to="/masterhome/home" />
            </Switch>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
